import { isIOS, isNonAmazonAndroid, isAmazon } from '../../environment/index'
import {
  URL_REMOTE_ACCOUNT_CREATE,
  URL_ACCOUNT,
  URL_GIFT,
  DEEP_LINK_HOME,
  DEEP_LINK_VIDEO,
  DEEP_LINK_SERIES,
  DEEP_LINK_VIDEO_PLAYER,
} from '../../services/url/constants'
import {
  isCart,
  isPlans,
  isGo,
  isLogout,
  isVideo,
  isSeries,
  isGetStarted,
  isSharePage,
  isPasswordReset,
} from '../../services/url/index'

/**
 * Get the deep link for the current path
 * @param {Map} resolver - The resolver
 * @returns {string}
 */
export function getDeepLink (resolver) {
  const path = resolver.getIn(['data', 'path'])
  const id = resolver.getIn(['data', 'id'])
  const fullplayer = resolver.getIn(['query', 'fullplayer'])

  if (isVideo(path)) {
    return fullplayer ? `${DEEP_LINK_VIDEO_PLAYER}/${id}` : `${DEEP_LINK_VIDEO}/${id}`
  }

  if (isSeries(path)) {
    return `${DEEP_LINK_SERIES}/${id}`
  }
  return DEEP_LINK_HOME
}

export function checkShouldShowBanner (resolver) {
  const path = resolver.getIn(['data', 'path'])

  return !isCart(path)
  && !isPlans(path)
  && !isGo(path)
  && !isLogout(path)
  && !isSharePage(path)
  && !isGetStarted(path)
  && !isPasswordReset(path)
  && path !== '/dev/adyen'
  && path !== URL_REMOTE_ACCOUNT_CREATE
  && !path.startsWith(URL_ACCOUNT)
  && !path.startsWith(URL_GIFT)
  && (isIOS() || isNonAmazonAndroid() || isAmazon())
}
